import { getMenuImageApi } from "../../api/home/menuImageApi";
import {
    GET_MENU_IMAGE_SUCCESS,
    GET_MENU_IMAGE_FAILURE,
} from "../types";

export const getMenuSuccess = (data) => ({
  type: GET_MENU_IMAGE_SUCCESS,
  payload: data,
});

export const getMenuFailure = (error) => ({
  type: GET_MENU_IMAGE_FAILURE,
  payload: error,
});

export const getMenuImage = (postData) => {
  return (dispatch) => {
    getMenuImageApi(postData)
      .then((response) => {
        dispatch(getMenuSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getMenuFailure(error.message));
      });
  };
};
